import React, { useState } from "react";
import InfiniteCarousel from "react-leaf-carousel";
import { Link } from "react-router-dom";
// import models from "./models";
import {
  getSubCategoriasR as getSubCats,
  jsonDeserialize,
} from "../../API/request";

const Slider = ({ title, articulos = [] }) => {
  const [selected, setSelected] = useState(null);
  const [subCategorias, setSubCategorias] = useState(null);

  if (articulos.length === 0) return null;

  const closeContainer = () => {
    const container = document.getElementById("model-band-container");
    container.classList.remove("open");
    resetImgs();
    setTimeout(function () {
      setSelected(null);
    }, 200);
  };

  const resetImgs = () => {
    const imgs = document.querySelectorAll(".model-band-stripe-img");
    imgs.forEach((element) => {
      if (element.classList.contains("model-band-stripe-img-active")) {
        element.classList.remove("model-band-stripe-img-active");
        element.previousElementSibling.classList.toggle(
          "model-band-stripe-img-secondary"
        );
      }
    });
  };

  const handlerClickModel = (e, item) => {
    let temp = selected;
    setSelected((filter) => {
      temp = filter;
      return filter;
    });
    const container = document.getElementById("model-band-container");

    const prev = document.getElementById("model-first-img-" + item.idCategoria);
    const next = document.getElementById(
      "model-secondary-img-" + item.idCategoria
    );

    resetImgs();

    if (temp === null || temp?.idCategoria !== item.idCategoria) {
      setSelected(item);
      getSubCats(item.idCategoria)
        .then((res) => {
          prev.classList.toggle("model-band-stripe-img-secondary");
          next.classList.add("model-band-stripe-img-active");

          container.classList.add("open");

          let subCats = jsonDeserialize(res.data.data).data;
          setSubCategorias(subCats);
        })
        .catch(() => {
          console.log("ERORR - En la petición");
        });
    } else {
      closeContainer();
    }
  };

  const sideImage = (imgName = "") => {
    const name = imgName.split(".");
    return process.env.REACT_APP_IMAGE_PATH + name[0] + "-side." + name[1];
  };

  return (
    <div className="container-models">
      <h2>
        {title}
      </h2>
      <div className="container-slider">
        <InfiniteCarousel
          breakpoints={[
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 780,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 3,
              },
            },
          ]}
          dots={false}
          showSides={false}
          sidesOpacity={0.5}
          sideSize={0.1}
          slidesToScroll={1}
          slidesToShow={5}
          scrollOnDevice={false}
        >
          {articulos.map((item, i) => (
            <div
              key={i}
              className="model-band"
              onClick={(e) => handlerClickModel(e, item)}
            >
              <img
                id={"model-first-img-" + item.idCategoria}
                className="model-band-stripe-img"
                alt={item.nombre}
                src={sideImage(item.img)}
              ></img>
              <img
                id={"model-secondary-img-" + item.idCategoria}
                className="model-band-stripe-img model-band-stripe-img-secondary"
                alt={item.nombre}
                src={process.env.REACT_APP_IMAGE_PATH + item.img}
              ></img>
              <span>{item.nombre}</span>
            </div>
          ))}
        </InfiniteCarousel>
      </div>

      <div id="model-band-container" className={`model-band-container`}>
        <div className="model-band-container-header">
          <button className="btn-black btn-rounded" onClick={closeContainer}>
            X
          </button>
          <span className="model-band-title">{selected?.nombre}</span>
        </div>
        <div className="model-band-container-content">
          {subCategorias?.map((subModel, i) => {
            return (
              <Link
                className="model-band"
                key={i}
                to={
                  "/Lifestyle/accesorios/list/" +
                  selected?.idCategoria +
                  "/" +
                  subModel.idCategoria
                }
              >
                <img
                  className="model-band-stripe-img"
                  alt={subModel.nombre}
                  src={process.env.REACT_APP_IMAGE_PATH + subModel.img}
                ></img>
                <span>{subModel.nombre}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Slider;
